import { ComponentPropsWithoutRef, ReactNode } from 'react';
import { ButtonGroupWrapper, ButtonGroupWrapperType } from '@/components/Button/ButtonGroup/styles';

export type ButtonGroupType = ButtonGroupWrapperType &
  ComponentPropsWithoutRef<'div'> & {
    children: ReactNode;
  };

export const ButtonGroup = ({ gap = '20px', mobileStretch, children, ...rest }: ButtonGroupType) => {
  return (
    <ButtonGroupWrapper gap={gap} mobileStretch={mobileStretch} {...rest}>
      {children}
    </ButtonGroupWrapper>
  );
};
